import React from 'react';
import LaptopIcon from '@mui/icons-material/Laptop';
import { Tooltip, Box, ClickAwayListener } from '@mui/material';


export default function NonMobileFeature(props) {
  const {text} = props
  const [openTooltip, setOpenTooltip] = React.useState(false)


  const toggleTooltip = () => {
    setOpenTooltip((prev) => !prev)
  }
  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };
  const handleTooltipOpen = () => {
    setOpenTooltip(true);
    };

  
    return (
      <ClickAwayListener onClickAway={handleTooltipClose}>
        <Box
          style={{margin:'5px', 
          padding:'0px', 
          position:'relative', 
          top:'2px'
        }}
        onClick={toggleTooltip}
        onMouseEnter={handleTooltipOpen}
        onMouseLeave={handleTooltipClose}
        >
          <Tooltip title="Feature available on laptop/desktop"
            placement='top' 
            arrow
            open={openTooltip}
          >
              <LaptopIcon 
                sx={{
                  color:'rgb(150 100 0)',
                  fontSize: 'large',
                  paddingRight: '10px'
                  }} 
              />
          </Tooltip>
        </Box>
      </ClickAwayListener>
    );
}